module.exports = __webpack_public_path__ + "static/media/explosion-vfx.07ccdba7.glb";